import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MaphelperService } from '../../../../../src/app/app-analysis-module/maphelper.service';
import { IsochroneService } from '../../../../../src/app/isochrone-module/isochrone.service';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
  selector: 'lib-lasso-tools',
  standalone:true,
  imports:[CommonModule,MatTabsModule,FormsModule,MatIconModule,MatProgressSpinnerModule,MatFormFieldModule,MatButtonModule,FlexLayoutModule],
  templateUrl: './lasso-tools.component.html',
  styleUrls: ['./lasso-tools.component.css']
})
export class LassoToolsComponent implements OnInit {

  activeDrawTool: any
  isCircleBox:any = false;
  circleRadius1:any = 100;
  abc: any
  isdrawingActive:any = false;
  @Input() draw: any
 
  disableButton:boolean=false
  @Input() moduleName: any
 
  @Input('closeEnable')set closeEnable(value:boolean) {
      this.drawFreeHand = value  
  }

  



  @Output() changeDrawModeEmit = new EventEmitter<any>()
  @Output() stopDrawEmit = new EventEmitter<any>()
  @Output() resetEmit = new EventEmitter<any>()
  @Output() lassoDrawEmit = new EventEmitter<any>()
  drawCircle: boolean = false;
  drawRectangle: boolean = false;
  drawPolygon: boolean = false;
  drawFreeHand: boolean = false;
  @Input() Loader: any
  @Output() LassoReset:EventEmitter<any> = new EventEmitter<any>();
  @Output() OnSubmitDataCollection:EventEmitter<any> = new EventEmitter<any>();
  @Input() mapCarto: any
  @Input() resetHigh: any
  @Input() TerritoryLayerData:any;
  constructor(private maphelperService: MaphelperService,private _isochroneService:IsochroneService) { }

  ngOnInit() {
    // console.warn(this.circleRadius1)
    // this.mapCarto.on('click', (e) => {
    //   if(this.activeDrawTool == 'circle'){
    //   console.warn(this.circleRadius1)
    //      this.drawCircle1() 
    //   }
    // })
    this._isochroneService.ResetLassoHighlight.subscribe(res=>{
      if(res){
        this.onResetButton()
      }
    })
 
    if(this.moduleName == 'buffer-analysis' || this.moduleName == 'Assign_User' ){
      this.selectAll = true
    }

  }
  onChange(data: any){
    console.warn(data)
    console.warn(this.circleRadius1)
         this.drawCircle1() 
  }

  ngOnChanges(changes: SimpleChanges){
    try{
      if(changes["resetHigh"].currentValue == true){
        this.onResetButton()
      }
    }catch{}


  }

  activeTabIndex: number = 0;

  clearTabHighlights() {
      this.activeTabIndex = -1;
  }


  listenMapPopUpFn() {
    this.maphelperService.ListenMapPopup.next(true);
  }


  clickClearAll() {
    this.maphelperService.ListenMapPopup.next(true);
    this.isCircleBox = false;
    this.draw.deleteAll();
    this.abc = "";
  }
  selectAll = false
  @Output() lassoDrawTypeEmit = new EventEmitter()
  clickDrawBtn(check: string) {
    this.disableButton=true
    const drawingMessageDiv = document.getElementById('drawing-message');
    if (drawingMessageDiv) {
        // Toggle the display style between 'block' and 'none'
        drawingMessageDiv.style.display = (drawingMessageDiv.style.display === 'none') ? 'block' : 'none';
    }
    
    if (check !== this.activeDrawTool) {
        // this.lassoDrawEmit.emit(true);
        this.lassoDrawTypeEmit.emit(check)
        if (check == "circle") {
            this.drawRectangle = false;
            this.drawPolygon = false;
            this.drawFreeHand = false;
            this.drawCircle = true;
            this.activeDrawTool = 'circle';
            this.selectAll = false
            this.drawCircle1();
        } else if (check == "rectangle") {
            this.drawCircle = false;
            this.drawPolygon = false;
            this.drawFreeHand = false;
            this.drawRectangle = true;
            this.activeDrawTool = 'rectangle';
            this.selectAll = false
            this.drawRectangle1();
        } else if (check == "free-hand") {
            this.drawRectangle = false;
            this.drawPolygon = false;
            this.drawCircle = false;
            this.drawFreeHand = true;
            this.activeDrawTool = 'free-hand';
            this.drawFreeHand1();
            this.selectAll = false
        } else if (check == "polygon") {
            this.drawRectangle = false;
            this.drawFreeHand = false;
            this.drawCircle = false;
            this.drawPolygon = true;
            this.activeDrawTool = 'polygon';
            this.drawPolygon1();
            this.selectAll = false
        } else if (check =='all') {
            this.drawRectangle = false;
            this.drawFreeHand = false;
            this.drawCircle = false;
            this.drawPolygon = false;
            this.selectAll = true
            this.activeDrawTool = '';
            this.onResetButton()
            this.lassoDrawEmit.emit(false);
            this.stopDrawEmit.emit();
            this.changeDrawModeEmit.emit({ type: '', mode: '' })
        } else if (check=='stop') {
            // this.changeDrawModeEmit.emit({ type: '', mode: '' })
            this.drawRectangle = false;
            this.drawFreeHand = false;
            this.drawCircle = false;
            this.disableButton=false
            this.drawPolygon = false;
            this.stopDrawEmit.emit();
            this.activeDrawTool = '';
            this.lassoDrawEmit.emit(false);
            


        }
    } else {
        this.changeDrawModeEmit.emit({ type: '', mode: '' })
        this.drawRectangle = false;
        this.drawFreeHand = false;
        this.drawCircle = false;
        this.drawPolygon = false;
        this.stopDrawEmit.emit();
        this.activeDrawTool = '';
        this.disableButton=true
        this.lassoDrawEmit.emit(false);
    }
}




  onResetButton() {
    this.disableButton=false
    this.drawRectangle = false;
    this.drawFreeHand = false;
    this.drawCircle = false;
    this.drawPolygon = false;
    this.resetEmit.emit(true);
    this.draw.deleteAll();
    this.abc = "";
    this.isCircleBox = false;
    this.maphelperService.ListenMapPopup.next(true);
    this.circleRadius1 = 100;
    this.LassoReset.emit(true)
    this.activeDrawTool = ''; // Set activeDrawTool to an empty string to hide the stop button


  }

  drawCircle1() {
    if (this.moduleName !== "add polygon") {
      this.draw.deleteAll();
      this.draw.changeMode('draw_circle', { initialRadiusInKm: this.circleRadius1 });
    }
    this.changeDrawModeEmit.emit({ type: 'circle', mode: 'draw_circle', circleRadius: this.circleRadius1 })
    this.isdrawingActive = true;
    // this.maphelperService.ListenMapPopup.next(false);
    console.log(this.circleRadius1)
    this.isCircleBox = true;
    console.log("bounding coorinates in circle === ", this.abc);
  }

  drawRectangle1() {
    if (this.moduleName !== "add polygon") {
      this.draw.deleteAll();
      // this.draw.changeMode('draw_rectangle');
    }
    this.changeDrawModeEmit.emit({ type: 'rectangle', mode: 'draw_rectangle' })
    this.isdrawingActive = true
    // this.maphelperService.ListenMapPopup.next(false);
    this.isCircleBox = false;
    console.log("Draw Rectangle");
    console.log("bounding coorinates in rectangle === ", this.abc);
  }

  drawPolygon1() {
    if (this.moduleName !== "add polygon") {
      this.draw.deleteAll();
      this.draw.changeMode('draw_polygon',{ initialRadiusInKm:0 });
    }
    this.changeDrawModeEmit.emit({ type: 'polygon', mode: 'draw_polygon' })
    this.isdrawingActive = true
    // this.maphelperService.ListenMapPopup.next(false);
    this.isCircleBox = false;
    console.log("Draw Polygon");
    console.log("bounding coorinates in Polygon === ", this.abc);
  }


  drawFreeHand1() {
    if (this.moduleName !== "add polygon") {
      this.draw.deleteAll();
      this.draw.changeMode('draw_polygon',{ initialRadiusInKm:0 });
    }
    this.changeDrawModeEmit.emit({ type: 'draw-freehand', mode: 'draw_freeHand' })
    this.isdrawingActive = true
    // this.maphelperService.ListenMapPopup.next(false);
    this.isCircleBox = false;
    console.log("is polygon working");
    console.log("bounding coorinates in polygon === ", this.abc);
    

  }

  onDoneDataCollection(){
    this.OnSubmitDataCollection.emit(true)    
  }


  // drawPolygonFreeHand(){
  //   this.isdrawingActive = true
  //   this.maphelperService.ListenMapPopup.next(false);
  //   this.isCircleBox = false;
  //   this.draw.deleteAll();
  //   console.log("is polygon working");
  //   this.draw.changeMode('draw_FreeHand');
  //   console.log("bounding coorinates in polygon === ",this.abc);
  // }


}
